import { get, post, put, destroy } from './config';

const Localization = {
  getLocalizationByLang: (lang) =>
    get(`v1/localization/lang/${lang}`),
  getLocalizationById: (id) =>
    get(`v1/localization/${id}`),
  createLocalization: (data) =>
    post(`v1/localization`, data),
  updateLocalization: (id, data) =>
    put(`v1/localization/${id}`, data),
}
export default Localization;
